export const hasPermission = (permissionCode) => {
  const storedPermissions = localStorage.getItem("permissions");
  if (!storedPermissions) {
    return false;
  }
  try {
    const permissions = JSON.parse(storedPermissions);
    if (Array.isArray(permissions)) {
      const check = (perms) => {
        for (const p of perms) {
          if (p.code === permissionCode && p.active) {
            return true;
          }
          if (p.children && Array.isArray(p.children)) {
            if (check(p.children)) {
              return true;
            }
          }
        }
        return false;
      }
      return check(permissions);
    }
  } catch (e) {
    console.error("Error parsing permissions from localStorage", e);
  }
  return false;
}; 